import { render, staticRenderFns } from "./SubjectModuleList.vue?vue&type=template&id=584141cc"
import script from "./SubjectModuleList.vue?vue&type=script&lang=js"
export * from "./SubjectModuleList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports